/**
 * External dependencies
 */
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

document.addEventListener( 'DOMContentLoaded', function () {
	tippy( '[data-tip]', {
		placement: 'top-start',
		maxWidth: '300px',
		allowHTML: true,
		// I'm not sure why this is needed.
		// https://stackoverflow.com/questions/55712386/tippy-js-not-displaying-content-from-the-data-attribute
		onShow( instance ) {
			instance.setContent( instance.reference.dataset.tip );
		},
	} );
} );
